import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import VendorsPage from './pages/VendorsPage';
import UsersPage from './pages/UsersPage';
import ActivityLogsPage from './pages/ActivityLogsPage';
import PartnersPage from './pages/PartnersPage';
import PartnerPortal from './pages/PartnerPortal';
import PhoneNumbersPage from './pages/PhoneNumbersPage';
import BanksPage from './pages/BanksPage';
import CompaniesPage from './pages/CompaniesPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import SystemHealthPage from './pages/SystemHealthPage';
import SecurityTimelinePage from './pages/SecurityTimelinePage';
import ImpersonationBanner from './components/ImpersonationBanner';
import { Toaster } from './components/ui/sonner';

function App() {
  useEffect(() => {
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.remove();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ImpersonationBanner />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors"
            element={
              <ProtectedRoute>
                <VendorsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies"
            element={
              <ProtectedRoute requiredRoles={['Super Admin']}>
                <CompaniesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute requiredRoles={['Admin', 'Sub Admin', 'Super Admin']}>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/activity-logs"
            element={
              <ProtectedRoute requiredRoles={['Admin', 'Super Admin']}>
                <ActivityLogsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partners"
            element={
              <ProtectedRoute requiredRoles={['Admin', 'Super Admin']}>
                <PartnersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/phone-numbers"
            element={
              <ProtectedRoute requiredRoles={['Admin', 'Sub-admin', 'Agent', 'Super Admin']}>
                <PhoneNumbersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/banks"
            element={
              <ProtectedRoute requiredRoles={['Admin', 'Sub-admin', 'Agent', 'Super Admin']}>
                <BanksPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute requiredRoles={['Admin', 'Sub Admin', 'Super Admin']}>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute requiredRoles={['Admin', 'Super Admin']}>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/security-timeline"
            element={
              <ProtectedRoute requiredRoles={['Super Admin']}>
                <SecurityTimelinePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/system-health"
            element={
              <ProtectedRoute requiredRoles={['Super Admin']}>
                <SystemHealthPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-banks"
            element={
              <ProtectedRoute requiredRoles={['Partner']}>
                <PartnerPortal />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
